<template>
  <div class="container-fluid">
    <div class="d-flex align-items-center">
      <div>
        <template v-if="hasRole('manager')">
          <router-link :to="isCurrentDepartment('iso-progettazione') ? '/manager' : '/check-in'"
            class="btn rounded-btn-custom shadow bg-violet text-white mt-3">
            <div class="d-flex align-items-center">
              <ChevronLeft color="white" class="me-2"/>
              <span class="text-uppercase">Check-in</span>
            </div>
          </router-link>
        </template>
        <Brand :width="110" :height="110" />
      </div>
      <div
        class="alert alert-primary d-flex flex-column mx-3 px-4 rounded-custom" >
        <span
          v-for="option in testWorkQueueTypesOptions"
          :key="option.value"
          class="my-1 d-flex align-items-center">
          <img
            :src="require(`@/assets/icons/${option.icon}`)"
            width="25"
            :alt="option.value"
            class="me-2">
          {{ option.label }}
        </span>
      </div>
    </div>

    <div class="table-responsive p-0 bg-white rounded-custom mb-2 position-relative" :class="{ 'min-height-custom': !pendingTestWorkQueuePhase.length }">
      <div class="d-flex">
        <div class="d-flex align-items-center">
          <h3 class="text-violet mx-3 mb-0">Totale da assegnare: {{ totalItems }}</h3>
        </div>
        <div class="d-flex align-items-center px-3">
          <label class="form-label me-2 mb-0 text-violet fw-bold">Filtra per tipologia:</label>
          <Multiselect
            @change="onTypeFilterChange"
            v-model="selectedTypes"
            :options="testWorkQueueTypesOptions"
            mode="tags"
            :close-on-select="false"
            :clear-on-select="false"
            :max="3"
            placeholder="Seleziona tipologie..."
            class="me-3 multiselect-violet rounded-custom"
            style="min-width: 250px;"
          />
        </div>
        <GlobalSearch
          class="p-4 flex-grow-1"
          :placeholder="'Ricerca per prescrizione...'"
          :debounceTime="150"
          @toSearch="readValueToSearch"
        />

      </div>

      <table class="table table-bordered table-hover m-0">
        <thead class="bg-light-violet text-black">
          <tr>
            <th scope="col">PRESCRIZIONE</th>
            <th scope="col">TIPOLOGIA</th>
            <th scope="col">DATA ETICHETTA</th>
            <th scope="col">PAZIENTE</th>
            <th scope="col">PRESTAZIONE</th>
            <th scope="col">PROVA</th>
            <th scope="col">MATERIALE</th>
            <th scope="col">ELEMENTI</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <div class="position-absolute top-50 start-50 translate-middle">
              <Spinner />
            </div>
          </template>
          <template v-else>
            <template v-if="pendingTestWorkQueuePhase.length">
              <tr v-for="(twqp, index) in pendingTestWorkQueuePhase" :key="index" class="testWorkQueuePhase"
                  :class="[
                    {'selected': idsTestWorkQueuePhaseToAssign.includes(twqp.id), 'hide': twqp.hide}
                  ]"
                  @click="toggleSelected(twqp, $event)">
                <td nowrap class="align-middle">
                  <span class="ms-2">{{ twqp.prescriptionInfo.number_text }}</span>
                </td>
                <td nowrap class="align-middle text-center">
                  <span class="mx-1">{{ twqp.isDigital ? 'Dig.' : 'Analog.' }}</span>
                  <img
                    v-for="type in twqp.test_work_queue?.types"
                    :key="type.slug"
                    :src="require(`@/assets/icons/${getTestWorkQueueTypeIcon(type.slug)}`)"
                    :title="type.name"
                    width="25"
                    alt="Type"
                    class="mx-1" />
                </td>
                <td nowrap class="align-middle">{{ moment(twqp.delivery_date).format("DD/MM/YYYY HH:mm:ss") }}</td>
                <td class="align-middle">{{ twqp.customer }}</td>
                <td class="align-middle text-truncate"
                    style="max-width: 300px;"
                    data-bs-toggle="tooltip" data-bs-placement="top" :title="getPrescriptionRows(twqp.prescription_rows)">
                  {{ getPrescriptionRows(twqp.prescription_rows) }}
                </td>
                <td class="align-middle">{{ twqp.test }}</td>
                <td class="align-middle">{{ twqp.material }}</td>
                <td class="align-middle">{{ twqp.prescriptionInfo.number_elements }}</td>
              </tr>
            </template>
            <template v-else>
              <h4 class="position-absolute top-50 start-50 translate-middle">Nessuna lavorazione presente</h4>
            </template>
          </template>
        </tbody>
      </table>
    </div>

    <template v-if="pendingTestWorkQueuePhase.length">

      <div class="d-flex justify-content-between mt-3">
        <div class="actions">
          <router-link to="/manager" class="btn rounded-btn-custom shadow bg-violet text-white">
            <div class="d-flex align-items-center">
              <ChevronLeft color="white" class="me-2"/>
              <span class="text-uppercase">Manager</span>
            </div>
          </router-link>
          <button type="button" class="btn btn-violet text-uppercase justify-content-start ms-2"
                  :disabled="!idsTestWorkQueuePhaseToAssign.length"
                  @click="showTechnicianModal()">
            {{ getLabel() }}
          </button>
        </div>

        <Pagination
          :total-pages="totalPages"
          :page-number="pageNumber"
          :array="idsTestWorkQueuePhaseToAssign"
          show-first-page
          show-last-page
          @increment="() => pageNumber++"
          @decrement="() => pageNumber--"
          @goToFirst="pageNumber = 1"
          @goToLast="pageNumber = totalPages"
        />

      </div>

    </template>

  </div>

  <Empty v-if="techniciansModal"
         :size="'md'"
         :modal_id="'techniciansModal'"
         @hidden="closeTechnicianModal">
    <SpecialActions
      style="height: 400px;"
      :title="technicianModalTitle"
      :placeholderNameSelect="'seleziona il tecnico...'"
      :optionsSelect="technicians"
      :notesMode="'disabled'"
      @selected="technicianIdSelected"
      @clear="clearTechnicianIdSelected"
      @store="save"
      @close="closeTechnicianModal"
    />
  </Empty>

  <StuckWorkWarningProvider />
</template>

<script>
import GlobalSearch from "@/components/GlobalSearch";
import Multiselect from "@vueform/multiselect";
import {
  computed,
  defineComponent,
  getCurrentInstance, inject,
  onMounted,
  onUnmounted,
  ref,
  toRaw,
  watch
} from "vue";
import { pending as fetchPendingTestWorkQueuePhase } from "@/use/repositories/testWorkQueuePhase/pending";
import { fetchById as fetchTestWorkQueueById } from "@/use/repositories/testWorkQueuePhase/fetchById";
import {hideModal as closeModal} from '@/use/modal/hide';
import {fetchByDepartmentSlug} from "@/use/repositories/users/fetchByDepartmentSlug";
import Empty from "@/components/Modal/Empty";
import Spinner from "@/components/general/Spinner";
import SpecialActions from "@/components/SpecialActions";
import {useStore} from "vuex";
import moment from 'moment';
import Brand from "@/components/Brand";
import _ from 'lodash';
import {update as updateTestWorkQueuePhase} from "@/use/repositories/testWorkQueuePhase/update";
import { isCurrentDepartment } from "@/use/utilities/isCurrentDepartment";
import {useI18n} from "vue-i18n";
import {info} from '@/use/toast/info'
import {success} from "@/use/toast/success";
import ChevronLeft from "@/components/Icons/ChevronLeft";
import Pagination from "@/components/general/Pagination.vue";
import { hasRole } from "@/use/utilities/users/hasRole";
import { useStateIcon } from '@/composables/useStateIcon';
import axios from "axios";
import { useTestWorkQueueTypesOptions } from '@/composables/useTestWorkQueueTypesOptions';
import StuckWorkWarningProvider from '@/components/StuckWorkWarningProvider.vue';

export default defineComponent({
  name: "App",
  components: {
    Pagination,
    GlobalSearch,
    Multiselect,
    ChevronLeft,
    Brand,
    Empty,
    SpecialActions,
    Spinner,
    StuckWorkWarningProvider,
  },
  setup() {
    const { states } = inject("constants");
    const { getTestWorkQueueTypeIcon } = useStateIcon();
    const pendingTestWorkQueuePhase = ref([]);
    const pendingTestWorkQueuePhaseSelected = computed(() => {
      return pendingTestWorkQueuePhase.value.filter((twq) => {
        return idsTestWorkQueuePhaseToAssign.value.includes(twq.id);
      });
    });
    const idsTestWorkQueuePhaseToAssign = ref([]);
    const techniciansModal = ref(false);
    const technicians = ref([]);
    const technicianId = ref(null);
    const technicianModalTitle = computed(() => {
      let title = 'Seleziona il tecnico al quale assegnare ';
      if (idsTestWorkQueuePhaseToAssign.value.length === 1) {
        title += 'la lavorazione';
      } else {
        title += 'le lavorazioni';
      }
      return title;
    });
    const store = useStore();
    const pageNumber = ref(1);
    const totalPages = ref(null);
    const i18n = useI18n();
    let lastDeliveryDate = null;
    const loading = ref(true);
    const searchKeyword = ref(null);
    const totalItems = ref(0);
    const selectedTypes = ref([]);
    const currentRequestId = ref(0);

    const { testWorkQueueTypesOptions } = useTestWorkQueueTypesOptions();

    // Pusher.
    const internalInstance = getCurrentInstance();
    const pusher = internalInstance.appContext.config.globalProperties.$pusher;
    const subscribe = (channelName, eventName) => {
      console.log(`subscribing from "${channelName}"...`, { $pusher: pusher });
      const channel = pusher.subscribe(channelName);
      channel.bind("pusher:subscription_succeeded", () => console.log("subscription succeeded"));
      channel.bind(eventName, async (event) => {
        console.log("event received", event);
        let eventStateSlug = event.state.slug;

        if (!event.test_work_queue || !event.test_work_queue.delivery_date) {
          return;
        }

        // Push test work queue phase only if the date is less than the last record.
        if (moment(event.test_work_queue.delivery_date).isBefore(lastDeliveryDate)) {
          let eventTestWorkQueueId = event.id;
          fetchTestWorkQueueById(eventTestWorkQueueId, 'with_pending', false).then((response) => {
            let testWorkQueuePhase = createTestWorkQueuePhasePendingObj(response.testWorkQueuePhase);
            // Checks states.
            if (eventStateSlug === states.PENDING) {
              // Remove last test work queue.
              pendingTestWorkQueuePhase.value.pop();
              // Push event.
              pendingTestWorkQueuePhase.value.push(testWorkQueuePhase);
              // Reorder by delivery date.
              pendingTestWorkQueuePhase.value = _.orderBy(toRaw(pendingTestWorkQueuePhase.value), 'delivery_date');
              // notifications.
              info(i18n.t('A new processing has arrived!'));
              setTimeout(() => {
                success(i18n.t('Reordering successful!'));
                success(i18n.t('New workings successfully recovered!'));
              }, 1000);
            } else {
              // Find index test work queue phase.
              let index = pendingTestWorkQueuePhase.value.findIndex((twqp) => parseInt(twqp.id) === testWorkQueuePhase.id);
              if (index !== -1) {
                // Set disabled.
                pendingTestWorkQueuePhase.value[index].hide = true;
                // notifications.
                info(i18n.t('Job has changed status!'));
              }
            }
          });
        }
      });
    };
    const unsubscribeChannel = (channelName) => {
      console.log(`unsubscribing from "${channelName}"...`, { $pusher: pusher });
      console.log("unsubscribing...");
      pusher.unsubscribe(channelName);
    };

    onMounted(() => {
      // Subscribe to pusher channel.
      subscribe(`presence-user.${store.state.user.id}`, 'manager_change_phase_state');
      getData();
    });

    onUnmounted(() => {
      console.log("unmount");
      unsubscribeChannel(`presence-user.${store.state.user.id}`);
    });

    watch([pageNumber, searchKeyword, selectedTypes], () => {
      getData(pageNumber.value);
    }, { deep: true });

    const readValueToSearch = (value) => {
      searchKeyword.value = value;
      pageNumber.value = 1;
    }

    const onTypeFilterChange = () => {
      pageNumber.value = 1;
    }

    const getData = async (pageNumber) => {
      const requestId = ++currentRequestId.value;

      loading.value = true;
      pendingTestWorkQueuePhase.value = [];

      let data = {
        department_slug: store.state.mainRole.team.name,
        page: pageNumber,
      };

      // Attach keyword on request
      if (searchKeyword.value) {
        data = { ...data, keyword: searchKeyword.value };
      }

      if (selectedTypes.value && selectedTypes.value.length) {
        data = { ...data, type_slugs: selectedTypes.value };
      }

      clearAssigned();

      try {
        const { pendingTestWorkQueuePhases } = await fetchPendingTestWorkQueuePhase(data, false, { abort: true });

        if (requestId !== currentRequestId.value) return;

        totalPages.value = pendingTestWorkQueuePhases.meta.last_page;
        totalItems.value = pendingTestWorkQueuePhases.meta.total;
        if (pendingTestWorkQueuePhases.data.length) {
          const transformedData = transformData(pendingTestWorkQueuePhases.data);
          pendingTestWorkQueuePhase.value = transformedData;

          if (selectedTypes.value && selectedTypes.value.length) {
            totalItems.value = transformedData.length;
          }

          updateLastDeliveryDate();
        }
        const usersResp = await fetchByDepartmentSlug(store.state.mainRole.team.name);

        if (requestId !== currentRequestId.value) return;

          technicians.value = usersResp.usersDepartment.users.map((user) => ({
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        }));
      } catch (err) {
        const isAbort = axios.isCancel(err);
        if (!isAbort) {
          console.error('Errore caricamento pending manager:', err);
        }
      } finally {
        if (requestId === currentRequestId.value) {
          loading.value = false;
        }
      }
    }

    const updateLastDeliveryDate = () => {
      let lastIndex = (pendingTestWorkQueuePhase.value.length - 1);
      lastDeliveryDate = moment(pendingTestWorkQueuePhase.value[lastIndex].delivery_date);
    }

    const transformData = (data) => {
      return data
        .filter(testWorkQueuePhase => testWorkQueuePhase.test_work_queue?.prescription_test?.prescription)
        .filter(testWorkQueuePhase => {
          if (selectedTypes.value && selectedTypes.value.length) {
            const workQueueTypes = testWorkQueuePhase.test_work_queue?.types || [];
            const hasMatchingType = selectedTypes.value.some(selectedType =>
              workQueueTypes.some(type => type.slug === selectedType)
            );
            return hasMatchingType;
          }
          return true;
        })
        .map(testWorkQueuePhase => createTestWorkQueuePhasePendingObj(testWorkQueuePhase));
    };

    const createTestWorkQueuePhasePendingObj = (testWorkQueuePhase) => {
      return {
        id: testWorkQueuePhase.id,
        prescriptionInfo: {
          number_text: testWorkQueuePhase.test_work_queue.prescription_test.prescription?.number_text,
          number_elements: testWorkQueuePhase.test_work_queue.prescription_test.prescription?.prescription_rows_count,
        },
        isDigital: typeof testWorkQueuePhase.test_work_queue.prescription_test?.intraoral_scanner_id === 'number',
        delivery_date: testWorkQueuePhase.test_work_queue.delivery_date,
        customer: `${testWorkQueuePhase.test_work_queue.prescription_test.prescription.customer?.first_name} ${testWorkQueuePhase.test_work_queue.prescription_test.prescription.customer?.last_name}`,
        test: testWorkQueuePhase.test_work_queue.prescription_test.test?.name,
        prescription_rows: testWorkQueuePhase.test_work_queue.prescription_test.prescription?.prescription_rows,
        material: testWorkQueuePhase.test_work_queue.prescription_test.prescription?.material,
        hide: false,
        test_work_queue: testWorkQueuePhase.test_work_queue,
      }
    }

    const getPrescriptionRows = (prescriptionRows) => {
      let array = [];
      prescriptionRows.forEach((el) => {
        array.push(el.listRow.name);
      });
      return array.join(' / ');
    }

    const getLabel = () => {
      if (idsTestWorkQueuePhaseToAssign.value.length === 1) {
        return 'assegna la casella selezionata';
      }
      return 'assegna le caselle selezionate';
    }

    const toggleSelected = (twqp, event) => {
      // Find parent element.
      let element = event.target.closest('.testWorkQueuePhase');
      // Toggle selected class.
      element.classList.toggle("selected");
      // Toggle id.
      idsTestWorkQueuePhaseToAssign.value = _.xor(toRaw(idsTestWorkQueuePhaseToAssign.value), [twqp.id]);
    }

    // Close technician modal.
    const closeTechnicianModal = () => {
      closeModal('techniciansModal');
      setTimeout(() => {
        techniciansModal.value = false;
      }, 500);
    }
    // Read technician selected.
    const technicianIdSelected = (id) => {
      technicianId.value = id;
    }
    // Clear technician selected.
    const clearTechnicianIdSelected = () => {
      technicianId.value = null;
    }
    const showTechnicianModal = () => {
      techniciansModal.value = true;
    }
    // Save.
    const save = () => {
      updateTestWorkQueuePhase({
        source_ids: idsTestWorkQueuePhaseToAssign.value,
        user_id: technicianId.value,
        action: "attach_user",
      })
      .then(() => {
        setTimeout(() => success(i18n.t('Assignment was successful!')), 2000);
        closeTechnicianModal();
        syncData();
      });
    }

    const clearAssigned = () => {
      idsTestWorkQueuePhaseToAssign.value = [];
    }

    const syncData = () => {
      getData();
    }

    return {
      pendingTestWorkQueuePhase,
      moment,
      getPrescriptionRows,
      idsTestWorkQueuePhaseToAssign,
      techniciansModal,
      closeTechnicianModal,
      technicianModalTitle,
      technicianIdSelected,
      clearTechnicianIdSelected,
      save,
      pageNumber,
      totalPages,
      toggleSelected,
      showTechnicianModal,
      technicians,
      getLabel,
      pendingTestWorkQueuePhaseSelected,
      loading,
      readValueToSearch,
      totalItems,
      isCurrentDepartment,
      hasRole,
      getTestWorkQueueTypeIcon,
      selectedTypes,
      testWorkQueueTypesOptions,
      onTypeFilterChange
    };
  },
});
</script>

<style lang="scss" scoped>
  @import "../../scss/abstracts/_variables.scss";
  .hide {
    opacity: 0.2;
    pointer-events: none;
  }
 .testWorkQueuePhase:hover {
   cursor: pointer;
 }
 .min-height-custom {
   height: 740px;
 }
</style>

<style>
.multiselect-violet {
  --ms-tag-bg: #A58ABA !important;
  --ms-tag-color: #FFFFFF !important;
  --ms-ring-color: #F3E9FF !important;
  --ms-border-color: #D7DCE0 !important;
  --ms-border-color-active: #A58ABA !important;
  --ms-option-bg-selected: #A58ABA !important;
  --ms-option-color-selected: #FFFFFF !important;
}

.multiselect-violet .multiselect,
.multiselect-violet .multiselect-tag,
.multiselect-violet .multiselect-option,
.multiselect-violet .multiselect-dropdown {
  border-radius: 1rem !important;
}
</style>
